import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from "@angular/core";
import { ReportDataType } from "../../shared/enums/report-data-types.enum";
import { ExcelServicesService } from "../../services/excel.service";
import { NgxSpinnerService } from "ngx-spinner";

@Component({
  selector: "app-download-report",
  templateUrl: "./download-report.component.html",
  styleUrls: ["./download-report.component.css"],
})
export class DownloadReportComponent implements OnInit, OnChanges {
  @Input() reportDataList: any;
  @Input() reportHeadersKeys: [];
  @Input() total_count: number;
  @Output() onClickReportDownload: EventEmitter<any> = new EventEmitter();
  prolength = 1;
  //total_count = 0;
  isReportDownloadCliked = false;
  pageno: any;
  recrange: any;
  dropbox: any[];
  constructor(private excelService: ExcelServicesService,
              private spinner: NgxSpinnerService) {}

  ngOnChanges(changes: SimpleChanges): void {
    this.dropboxdown();
  }
  ngOnInit(): void {}

  getReportRowData(report, index) {
    let rowData = {"S.No": index+1};
    this.reportHeadersKeys.forEach((list: any) => {
      
      let value = report[list.keyName];
      if (list.typeof == ReportDataType.string) {
        // Capitalize first letters if the header is "First Name" or "Last Name"
        if (list.headerName.toLowerCase() === "first name" || list.headerName.toLowerCase() === "last name") {
          value = this.capitalizeWords(value);
        }    
        rowData[list.headerName] = value;
    } 
      if (list.headerName.toLowerCase() === "loggedin at") {
        if (value.length > 0) {
            const date = new Date(value[0].login_at);
            const formattedDate = date.toISOString().split('T')[0]; 
            const time = date.toTimeString().split(' ')[0];
            value = `${formattedDate} ${time}`;
        } else {
            value = ""; 
        }
        rowData[list.headerName] = value;
    }
    else if (list.typeof == ReportDataType.boolean) {
        rowData[list.headerName] = (report[list.keyName]) ? list.value[0] : list.value[1];
      } else if (list.typeof == ReportDataType.object) {
        rowData[list.headerName] = report[list.keyName][list.value];
      } else if (list.typeof == ReportDataType.array) {
        rowData[list.headerName] = report[list.keyName].map((e)=> e[list.value]).join(', ');
      }
    });
    return rowData;
  }
  capitalizeWords(value: string): string {
    return value.replace(/\b\w/g, (char) => char.toUpperCase());
  }

  async onReportDownload(event) {
    await this.onClickReportDownload.emit(event);
    this.isReportDownloadCliked = true;
  
  }
  getvalue(event: any, rec: any) {
    this.spinner.show();
    this.recrange = rec;
    this.pageno = event;
    //this.exportAsXLSX();
    var obj={
    download: true,
    pageno: this.pageno,
    pagesize: 1000
    }
    this.onReportDownload(obj);
  }
  processReportDownload(downloadData, report_name) {
    if (this.isReportDownloadCliked) {
    let reportDownloadList = [];
    downloadData.forEach((report, index) => {
        reportDownloadList.push(this.getReportRowData(report, index));
    });
  
    this.excelService.exportAsExcelFile(
        reportDownloadList,
        report_name + " " + [reportDownloadList.length]
    );
  }
    this.isReportDownloadCliked = false;

}
  async dropboxdown() {
    this.dropbox = [];
    var count = 1000,
      tempcount = 1000,
      c1,
      c2;
    let check = Math.ceil(this.total_count / count);
    var cvar = 1;
    for (let i = 1; i <= check; i++) {
      c1 = cvar;
      c2 = count;
      cvar = cvar + tempcount;
      count += tempcount;
      this.dropbox.push({ value: i, records: c1 + "-" + c2 });
    }
  }
}
